(() => {
  const boosterLabels = {
    'fr-fr': ['+ Booster :', 'Allonger', '(+ 30 €)'],
    'en-fr': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'de-de': ['+ Booster:', 'Verlängern', '(+ 30 €)'],
    'en-de': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'es-es': ['+ Booster:', 'Alargar', '(+ 30 €)'],
    'en-es': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'it-it': ['+ Booster:', 'Allungare', '(+ 30 €)'],
    'en-it': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'nl-nl': ['+ Booster:', 'Langer maken', '(+ €30)'],
    'en-nl': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'sv-se': ['+ Booster:', 'Gör längre', '(+ 300 kr)'],
    'en-se': ['+ Booster:', 'Make it Taller', '(+ kr 300)'],
    'da-dk': ['+ Booster:', 'Gør længere', '(+ 200 kr.)'],
    'en-dk': ['+ Booster:', 'Make it Taller', '(+ kr. 200)'],
    'ar-ae': ['+ Booster:', 'اجعله أطول', '(+ د.إ 130)'],
    'en-ae': ['+ Booster:', 'Make it Taller', '(+ AED 130)'],
    'hi-in': ['+ बूस्टर:', 'इसे लंबा बनाएं', '(+ ₹2750)'],
    'en-in': ['+ Booster:', 'Make it Taller', '(+ ₹2750)'],
    'en-ca': ['+ Booster:', 'Make it Taller', '(+ CA$30)'],
    'en-au': ['+ Booster:', 'Make it Taller', '(+ A$50)'],
    'en-gb': ['+ Booster:', 'Make it Taller', '(+ £25)'],
    'en-ie': ['+ Booster:', 'Make it Taller', '(+ €30)'],
    'en-us': ['+ Booster:', 'Make it Taller', '(+ $30)'],
    'default': ['+ Booster:', 'Make it Taller', '(+ $30)']
  };

  function getBoosterText() {
    const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const country = (window.Shopify?.country || 'US').toLowerCase();
    const key = `${lang}-${country}`;
    const [label, value, price] = boosterLabels[key] || boosterLabels.default;
    return `${label} ${value} ${price}`;
  }

  function updateCartBooster() {
    const replacement = getBoosterText();

    document.querySelectorAll('.product-cart-item-options').forEach(el => {
      let html = el.innerHTML;

      if (!/Add a Booster\?|Make it Tall(?:er)?/i.test(html)) return;

      html = html.replace(
        /Add a Booster\?.*?(?:Make it Tall(?:er)?)?(?:\s*\(\+.*?\))?/i,
        replacement
      );

      html = html.replace(
        /(?:<br\s*\/?>)?\s*Make it Tall(?:er)?(?:\s*\(\+.*?\))?/gi,
        ''
      );

      el.innerHTML = html;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateCartBooster();

    const observer = new MutationObserver(updateCartBooster);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(updateCartBooster, 500);
    setTimeout(updateCartBooster, 1500);
    setTimeout(updateCartBooster, 3000);
  });
})();